import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { FormControl, NgForm } from '@angular/forms';
import {AppService} from '../../../../app.service';
import {BonusService} from '../../bonus.service';
import {Constants} from '../../../../shared/utils/constants';
import {AutoComplete} from 'primeng/autocomplete';
import { startWith, switchMap } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { PreviewMailTemplateComponent } from '../preview-mail-template/preview-mail-template.component';
import { PreviewBonusMailTemplateProps } from '../preview-mail-template/preview-mail-template.types';
import { DatePipe } from '@angular/common';
import { MailTemplateToSave, PreviewEmailRequestProps } from '../promotion-bonus.type';

@Component({
  selector: 'fx-bonus-setting',
  templateUrl: './bonus-setting.component.html',
  styleUrls: ['./bonus-setting.component.sass'],
  providers: [DatePipe]
})
export class BonusSettingComponent implements OnInit {
  @ViewChild('formSetting') formSetting: NgForm;
  @ViewChild(AutoComplete) private autoComplete: AutoComplete;
  @ViewChild('previewMailOnCreate') previewMailOnCreatePopup: TemplateRef<HTMLDivElement>
  @Output() onUpdateHistory = new EventEmitter();

  bonus: any = {};
  viewBonus: any = {conditions: []};
  rateOrigin = null;
  targetName: any;
  listTarget = [];
  allTargets = [];
  sendMail = false;
  timeoutSelector = () => {
    const v = [];
    for(let i = 0; i <= 100; i ++) {
      v.push(i);
    }
    return v;
  }
  requestLoadHistory = '';
  targetControl = new FormControl();
  newTargetTemplate: MailTemplateToSave;
  constructor(
    private appService: AppService,
    private bonusService: BonusService,
    private readonly dialog: MatDialog,
    private readonly datePipe: DatePipe
  ) {}

  ngOnInit(): void {
    /*setTimeout(() => this.dialog.open(this.previewMailOnCreatePopup), 1000)*/
    this.initForm();
    this.getRate('usdjpy');
    this.bonusService.searchLevelOneByName({ q: '' }).subscribe(res => {
      if (res.status === Constants.RESPONSE_STATUS.SUCCESS) {
        this.allTargets = res.data;
      }
    });
    this.targetControl.valueChanges.pipe(
      startWith('')
    ).subscribe(e => {
      if (typeof e === 'string') {this.onLoadData(e);}
    });
  }
  onLoadData(event): void {
    const option = {
      q: event
    };

    this.bonusService.searchLevelOneByName(option).subscribe(res => {
      if (res.status === Constants.RESPONSE_STATUS.SUCCESS) {
        this.listTarget = res.data;
      }
    });
  }

  onBlurData(): void {
    if (this.targetName) {
      if (this.bonus.user_id === null && this.listTarget.length > 0) {
        this.bonus.email = this.listTarget[0].email;
        this.bonus.user_id = this.listTarget[0].user_id;
      }
    } else {
      this.bonus.email = '';
      this.bonus.user_id = null;
    }
  }

  displayFn(user): string {
    return user && user.email;
  }
  onSelectData(event): void {
    this.bonus.email = event?.email;
    this.bonus.user_id = event?.user_id;
  }
  saveSetting(): void {
    let validEmail = false;
    if(typeof this.targetControl.value === 'string') {
      validEmail = this.allTargets.find(e => e.email === this.targetControl.value);
    }
    if(typeof this.targetControl.value === 'object') {
      validEmail = this.allTargets.find(e => e.email === this.targetControl.value?.email);
    }
    if (!this.formSetting.valid || (this.bonus.name?.trim().length === 0) || !validEmail) {
      this.appService.showError('Please enter param setting bonus');
      return;
    }
    const body = JSON.parse(JSON.stringify(this.bonus));
    body.name = this.bonus.name?.trim();
    body.start_time = new Date(this.bonus.start_time).getTime();
    body.end_time = new Date(this.bonus.end_time).getTime();
    if (body.start_time > body.end_time) {
      this.appService.showError('Start time is less than or equal to end time.');
      return;
    }
    if (!body.is_enable_account && !body.is_enable_deposit) {
      this.appService.showError('Either Bonus on Deposit or Bonus On Open Account method must be set to ON');
      return;
    }
    body.data.deposit.multiple_time = body.data.deposit.multiple_time ? 1 : 0;
    body.data.deposit.distance_from_withdraw = 86400000 * +body.data.deposit.dfw;
    const mixConditions = [];
    if (body.is_enable_deposit) {
      body.data.deposit.conditions.map(f => {
        if(f.threshold && f.threshold !== '') {
          f.threshold = +f.threshold;
        }
        if(f.threshold === '') {
          f.threshold = null;
        }
          if (f.threshold !== null && f.threshold >= 0 && (f.rate && f.rate > 0)) {
            f.rate = +((f.rate / 100).toFixed(2));
            mixConditions.push(f);
          }
        }
      );
      // handle show message
      const mixRates = body.data.deposit.conditions
        .filter(f => (f.rate && f.rate > 0));
      const mixThreshold = body.data.deposit.conditions
        .filter(f => (f.threshold !== null && f.threshold >= 0));
      if (mixConditions.length !== mixRates.length
        || mixConditions.length !== mixThreshold.length) {
        this.appService.showError('Please enter param setting bonus');
        return;
      }
      const [c1,c2,c3,c4] = body.data.deposit.conditions;
      const sync1 = c2.threshold && !c1.threshold;
      const sync20 = c3.threshold && !c1.threshold && !c2.threshold;
      const sync21 = c3.threshold && !c1.threshold;
      const sync22 = c3.threshold && !c2.threshold;
      const sync30 = c4.threshold && !c1.threshold && !c2.threshold && !c3.threshold;
      const sync31 = c4.threshold && !c1.threshold && !c2.threshold && c3.threshold;
      const sync32 = c4.threshold && !c3.threshold && !c2.threshold && c1.threshold;
      const sync33 = c4.threshold && c2.threshold && c3.threshold && !c1.threshold;
      const sync34 = c4.threshold && c1.threshold && c3.threshold && !c2.threshold;
      const sync35 = c4.threshold && c1.threshold && c2.threshold && !c3.threshold;
      const sync36 = c4.threshold && c2.threshold && !c1.threshold && !c3.threshold;

      if(sync36) {
        this.appService.showError('Condition 1 & Condition 3 entry is required');
        return;
      }
      if(sync35) {
        this.appService.showError('Condition 3 entry is required');
        return;
      }
      if(sync32) {
        this.appService.showError('Condition 2 & Condition 3 entry is required');
        return;
      }
      if(sync30) {
        this.appService.showError('Condition 1 & Condition 2 & Condition 3 entry is required');
        return;
      }
      if(sync20 || sync31) {
        this.appService.showError('Condition 1 & Condition 2 entry is required');
        return;
      }
      if(sync22 || sync34) {
        this.appService.showError('Condition 2 entry is required');
        return;
      }
      if(sync1 || sync33 || sync21) {
        this.appService.showError('Condition 1 entry is required');
        return;
      }

      const [{threshold: t1}, {threshold: t2}, {threshold: t3}, {threshold: t4}] = body.data.deposit.conditions;
      if (t1 && t2 && !t3 && !t4 && !(t1 < t2) && body.is_enable_deposit) {
        this.appService.showError('Amount conditions entry rule: Condition 1 < Condition 2');
        return;
      }
      if (t1 && t2 && t3 && !t4 && !(t1 < t2 && t2 < t3) && body.is_enable_deposit) {
        this.appService.showError('Amount conditions entry rule: Condition 1 < Condition 2 < Condition 3');
        return;
      }
      if (t1 && t2 && t3 && t4 && !(t1 < t2 && t2 < t3 && t3 < t4) && body.is_enable_deposit) {
        this.appService.showError('Amount conditions entry rule: Condition 1 < Condition 2 < Condition 3 < Condition 4');
        return;
      }
    } else{
      delete body.data.deposit.up_limit;
      delete body.data.deposit.conditions;
    }

    body.data.deposit.conditions = mixConditions;
    if (!body.is_enable_account) {
      delete body.data.open_account.usd_bonus;
      delete body.data.open_account.jpy_bonus;
    }
    const createWithSendMail = {
      ...(this.newTargetTemplate && this.sendMail && {email_new_target_promotion_content: this.newTargetTemplate})
    }
    Object.assign(body, {send_email_to: this.sendMail ? ['new-target-all'] : [], ...createWithSendMail});
    // check user_id null
    if (body.user_id === null) {
      this.appService.showError('Please enter target person setting bonus');
      this.targetName = undefined;
      return;
    }

     this.appService
      .confirm({
        title: `Are you sure that you want to apply?`,
        ok: 'Yes',
        cancel: 'No',
      })
      .subscribe((v: any) => {
        if (v.result) {
          this.bonusService.createBonusEvents(body)
            .subscribe(res => {
              if (res.status === Constants.RESPONSE_STATUS.SUCCESS) {
                this.appService.showSuccess('Create events bonus success');
                this.sendMail = false;
                this.initForm();
                this.onUpdateHistory.emit(res.data.code);
                this.requestLoadHistory = res.data.code;
                this.onLoadData('')
              }
            });
        }
      });
  }
  getRate(baseSymbol): void {
    const option = {
      symbol: baseSymbol
    };
    this.bonusService.getRateBySymbol(option).subscribe(res => {
      if (res.status === Constants.RESPONSE_STATUS.SUCCESS) {
        this.rateOrigin = res.data.rate;
      }
    });
  }
  onUpdateRateUJ(key, index): void {
    if (key === 'conditions') {
      const baseValue = this.bonus.data.deposit.conditions[index].threshold;
      this.viewBonus.conditions[index].threshold = (baseValue / this.rateOrigin).toFixed(2);
    } else {
      this.viewBonus[key] = (this.bonus.data.deposit.up_limit / this.rateOrigin).toFixed(2);
    }
  }
  initForm(): void {
    this.targetName = undefined;
    this.targetControl.setValue(null);
    this.bonus = {
      is_enable_account: true,
      is_enable_deposit: true,
      data: {
        deposit: {
          up_limit: null,
          conditions: [
            {
              rate: null,
              threshold: null
            },
            {
              rate: null,
              threshold: null
            },
            {
              rate: null,
              threshold: null
            },
            {
              rate: null,
              threshold: null
            }
          ],
          dfw: 1,
          multiple_time: true,
        },
        open_account: {
          jpy_bonus: null,
          usd_bonus: null
        },
        bonus_type: 0
      },
      start_time: null,
      end_time: null,
      email: '',
      user_id: null
    };
    this.viewBonus = {
      up_limit_usd: null,
      conditions: [
        {
          threshold: null
        },
        {
          threshold: null
        },
        {
          threshold: null
        },
        {
          threshold: null
        }
      ]
    };
  }

  search() {}

  showPreviewOnCreate() {
    let validEmail = false;
    if(typeof this.targetControl.value === 'string') {
      validEmail = this.allTargets.find(e => e.email === this.targetControl.value);
    }
    if(typeof this.targetControl.value === 'object') {
      validEmail = this.allTargets.find(e => e.email === this.targetControl.value?.email);
    }
    if (!this.formSetting.valid || (this.bonus.name?.trim().length === 0) || !validEmail) {
      this.appService.showError('Please enter param setting bonus');
      return;
    }
    const body = JSON.parse(JSON.stringify(this.bonus));
    body.name = this.bonus.name?.trim();
    body.start_time = new Date(this.bonus.start_time).getTime();
    body.end_time = new Date(this.bonus.end_time).getTime();
    if (body.start_time > body.end_time) {
      this.appService.showError('Start time is less than or equal to end time.');
      return;
    }
    if (!body.is_enable_account && !body.is_enable_deposit) {
      this.appService.showError('Either Bonus on Deposit or Bonus On Open Account method must be set to ON');
      return;
    }
    body.data.deposit.multiple_time = body.data.deposit.multiple_time ? 1 : 0;
    body.data.deposit.dfw = Number(body.data.deposit.dfw);
    body.data.deposit.distance_from_withdraw = 86400000 * body.data.deposit.dfw;
    const mixConditions = [];
    if (body.is_enable_deposit) {
      body.data.deposit.conditions.map(f => {
          if(f.threshold && f.threshold !== '') {
            f.threshold = +f.threshold;
          }
          if(f.threshold === '') {
            f.threshold = null;
          }
          if (f.threshold !== null && f.threshold >= 0 && (f.rate && f.rate > 0)) {
            f.rate = +((f.rate / 100).toFixed(2));
            mixConditions.push(f);
          }
        }
      );
      // handle show message
      const mixRates = body.data.deposit.conditions
      .filter(f => (f.rate && f.rate > 0));
      const mixThreshold = body.data.deposit.conditions
      .filter(f => (f.threshold !== null && f.threshold >= 0));
      if (mixConditions.length !== mixRates.length
        || mixConditions.length !== mixThreshold.length) {
        this.appService.showError('Please enter param setting bonus');
        return;
      }
      const [c1,c2,c3,c4] = body.data.deposit.conditions;
      const sync1 = c2.threshold && !c1.threshold;
      const sync20 = c3.threshold && !c1.threshold && !c2.threshold;
      const sync21 = c3.threshold && !c1.threshold;
      const sync22 = c3.threshold && !c2.threshold;
      const sync30 = c4.threshold && !c1.threshold && !c2.threshold && !c3.threshold;
      const sync31 = c4.threshold && !c1.threshold && !c2.threshold && c3.threshold;
      const sync32 = c4.threshold && !c3.threshold && !c2.threshold && c1.threshold;
      const sync33 = c4.threshold && c2.threshold && c3.threshold && !c1.threshold;
      const sync34 = c4.threshold && c1.threshold && c3.threshold && !c2.threshold;
      const sync35 = c4.threshold && c1.threshold && c2.threshold && !c3.threshold;
      const sync36 = c4.threshold && c2.threshold && !c1.threshold && !c3.threshold;

      if(sync36) {
        this.appService.showError('Condition 1 & Condition 3 entry is required');
        return;
      }
      if(sync35) {
        this.appService.showError('Condition 3 entry is required');
        return;
      }
      if(sync32) {
        this.appService.showError('Condition 2 & Condition 3 entry is required');
        return;
      }
      if(sync30) {
        this.appService.showError('Condition 1 & Condition 2 & Condition 3 entry is required');
        return;
      }
      if(sync20 || sync31) {
        this.appService.showError('Condition 1 & Condition 2 entry is required');
        return;
      }
      if(sync22 || sync34) {
        this.appService.showError('Condition 2 entry is required');
        return;
      }
      if(sync1 || sync33 || sync21) {
        this.appService.showError('Condition 1 entry is required');
        return;
      }

      const [{threshold: t1}, {threshold: t2}, {threshold: t3}, {threshold: t4}] = body.data.deposit.conditions;
      if (t1 && t2 && !t3 && !t4 && !(t1 < t2) && body.is_enable_deposit) {
        this.appService.showError('Amount conditions entry rule: Condition 1 < Condition 2');
        return;
      }
      if (t1 && t2 && t3 && !t4 && !(t1 < t2 && t2 < t3) && body.is_enable_deposit) {
        this.appService.showError('Amount conditions entry rule: Condition 1 < Condition 2 < Condition 3');
        return;
      }
      if (t1 && t2 && t3 && t4 && !(t1 < t2 && t2 < t3 && t3 < t4) && body.is_enable_deposit) {
        this.appService.showError('Amount conditions entry rule: Condition 1 < Condition 2 < Condition 3 < Condition 4');
        return;
      }
    } else{
      delete body.data.deposit.up_limit;
      delete body.data.deposit.conditions;
    }

    body.data.deposit.conditions = mixConditions;
    if (!body.is_enable_account) {
      delete body.data.open_account.usd_bonus;
      delete body.data.open_account.jpy_bonus;
    }
    this.bonusService.getPreviewMailTemplate({
      ...body,
      email_type: 'new-target'
    }).pipe(
      switchMap(({data: {subject, html}}: PreviewEmailRequestProps) => {
        return this.dialog.open(PreviewMailTemplateComponent, {
          panelClass: 'preview-mail-template-by-popup',
          data: {
            content: html,
            subject,
            target: `${this.bonus.email || 'Target user'} and users under this user`
          } as PreviewBonusMailTemplateProps
        }).afterClosed()
      })).subscribe(({template}) => {
        if(template) {
          const {content: html, subject} = template;
          this.newTargetTemplate = {html, subject}
        }
    })
  }
}
